<template>
  <head>
    <meta charset="utf-8" />
    <title>CBHI | Household Management</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Manage households in your kebele" name="description" />
    <meta content="CBHI System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Household Management</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">HEW</a></li>
                    <li class="breadcrumb-item active">Households</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Alerts -->
          <div v-if="alert.success" class="alert alert-success" role="alert">
            {{message}}
          </div>
          <div v-if="alert.info" class="alert alert-primary" role="alert">
            {{message}}
          </div>
          <div v-if="alert.failed" class="alert alert-danger" role="alert">
            {{message}}
          </div>

          <!-- Statistics Cards -->
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Households</p>
                      <h5 class="mb-0">{{ total || 0 }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="bx bx-home"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">CBHI Enrolled</p>
                      <h5 class="mb-0">{{ statistics.cbhi_enrolled || 0 }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="bx bx-check-shield"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Model Households</p>
                      <h5 class="mb-0">{{ statistics.model_households || 0 }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="bx bx-star"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Vulnerable</p>
                      <h5 class="mb-0">{{ statistics.vulnerable || 0 }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="bx bx-shield-x"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white d-flex justify-content-between align-items-center w-100 border-bottom-1 pb-3 border-bottom">
                  <!-- Filters -->
                  <div class="me-3 text-nowrap filter-tool-bar-btns">
                    <!-- Filter Dropdown -->
                    <div class="btn-group">
                      <button type="button" class="btn btn-light waves-effect" data-bs-toggle="dropdown">
                        <i class="bx bx-filter font-size-16 me-1 align-middle"></i>
                        {{ getFilterLabel() }}
                      </button>
                      <div class="dropdown-menu">
                        <a class="dropdown-item" @click="filterHouseholds('all')">All Households</a>
                        <a class="dropdown-item" @click="filterHouseholds('cbhi')">CBHI Members</a>
                        <a class="dropdown-item" @click="filterHouseholds('non-cbhi')">Non-CBHI</a>
                        <a class="dropdown-item" @click="filterHouseholds('model')">Model Households</a>
                        <a class="dropdown-item" @click="filterHouseholds('vulnerable')">Vulnerable</a>
                      </div>
                    </div>

                    <!-- Clear Filter -->
                    <button v-if="filter !== 'all' || searchQuery.trim()" type="button" class="btn btn-danger waves-effect ms-2"
                            @click="clearFilter">
                      <i class="bx bx-x font-size-16 me-1 align-middle"></i> Clear
                    </button>
                  </div>

                  <div class="btn-toolbar d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input
                              v-model="searchQuery"
                              @input="onSearchInput"
                              @keyup.enter="performSearch"
                              type="text"
                              class="form-control bg-light border-light rounded"
                              placeholder="Search by household number, head name, or phone..."
                              :disabled="loading">
                          <i class="bx bx-search-alt search-icon"
                             @click="performSearch"
                             style="cursor: pointer;"></i>
                          <!-- Loading indicator for search -->
                          <div v-if="searchLoading" class="position-absolute"
                               style="top: 50%; right: 35px; transform: translateY(-50%);">
                            <div class="spinner-border spinner-border-sm text-primary" role="status">
                              <span class="visually-hidden">Searching...</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex gap-2">
                      <!-- Map View -->
                      <button @click="showMapView = true" type="button" class="btn btn-outline-primary">
                        <i class="bx bx-map"></i> <span class="d-md-inline ms-1">Map View</span>
                      </button>

                      <!-- Register New -->
                      <button @click="showRegisterModal = true" type="button" class="btn btn-primary">
                        <i class="bx bx-plus"></i> <span class="d-md-inline ms-1">New Household</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Search Results Info -->
                  <div v-if="searchQuery.trim() && !loading" class="mb-3">
                    <div class="alert alert-info py-2">
                      <i class="bx bx-info-circle me-1"></i>
                      <span v-if="total > 0">
                        Found {{ total }} household{{ total !== 1 ? 's' : '' }} matching "{{ searchQuery }}"
                      </span>
                      <span v-else>
                        No households found matching "{{ searchQuery }}"
                      </span>
                    </div>
                  </div>

                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3">{{ searchQuery.trim() ? 'Searching households...' : 'Loading households...' }}</p>
                  </div>

                  <!-- No Data State -->
                  <div v-else-if="!loading && households.length === 0" class="text-center py-5">
                    <i class="bx bx-home text-muted" style="font-size: 48px;"></i>
                    <p class="mt-3 text-muted">
                      {{ searchQuery.trim() ? 'No households found matching your search' : 'No households found' }}
                    </p>
                    <button v-if="searchQuery.trim() || filter !== 'all'"
                            @click="clearFilter"
                            class="btn btn-outline-primary">
                      <i class="bx bx-refresh me-1"></i> Show All Households
                    </button>
                  </div>

                  <!-- Data Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover border table-striped text-nowrap mb-0">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">Household</th>
                        <th scope="col">Head of Household</th>
                        <th scope="col">Members</th>
                        <th scope="col">CBHI Status</th>
                        <th scope="col">Special Status</th>
                        <th scope="col">Last Visit</th>
                        <th scope="col" class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="household in households" :key="household.household_id"
                          class="cursor-pointer" @click="viewHousehold(household)">
                        <td>
                          <div>
                            <h6 class="mb-0" v-html="highlightSearchTerm(household.household_number)"></h6>
                            <small class="text-muted">{{ household.kebele_name }}</small>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs me-2">
                              <div class="avatar-title bg-primary text-white rounded-circle">
                                {{ getInitials(household.household_head_name) }}
                              </div>
                            </div>
                            <div>
                              <h6 class="mb-0" v-html="highlightSearchTerm(household.household_head_name || 'Not assigned')"></h6>
                              <small class="text-muted" v-html="highlightSearchTerm(household.head_phone || 'No phone')"></small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="fw-bold">{{ household.member_count || 0 }}</span> total
                            <div class="text-muted small">
                              <span v-if="household.under_five_count > 0" class="text-warning">
                                <i class="bx bx-child"></i> {{ household.under_five_count }}
                              </span>
                              <span v-if="household.pregnant_women_count > 0" class="text-danger ms-2">
                                <i class="bx bx-female"></i> {{ household.pregnant_women_count }}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span v-if="household.cbhi_member_count > 0" class="badge bg-success">
                            CBHI Active ({{ household.cbhi_member_count }})
                          </span>
                          <span v-else class="badge bg-secondary">
                            Non-CBHI
                          </span>
                        </td>
                        <td>
                          <span v-if="household.is_model_household" class="badge bg-warning me-1">
                            <i class="bx bx-star"></i> Model
                          </span>
                          <span v-if="household.is_vulnerable" class="badge bg-danger">
                            <i class="bx bx-shield-x"></i> Vulnerable
                          </span>
                          <span v-if="household.is_female_headed" class="badge bg-info">
                            Female Headed
                          </span>
                        </td>
                        <td>
                          <div v-if="household.last_visit_date">
                            {{ formatDate(household.last_visit_date) }}
                            <div class="text-muted small">
                              {{ getDaysSinceVisit(household.last_visit_date) }} days ago
                            </div>
                          </div>
                          <span v-else class="text-muted">Never visited</span>
                        </td>
                        <td class="text-center" @click.stop>
                          <div class="btn-group" role="group">
                            <button @click="startVisit(household)" class="btn btn-sm btn-success"
                                    title="Start Visit">
                              <i class="bx bx-home-circle"></i>
                            </button>
                            <button @click="viewHousehold(household)" class="btn btn-sm btn-primary"
                                    title="View Details">
                              <i class="bx bx-show"></i>
                            </button>
                            <button @click="editHousehold(household)" class="btn btn-sm btn-warning"
                                    title="Edit">
                              <i class="bx bx-edit"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div v-if="totalPages > 1" class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_info">
                        Showing {{ (currentPage - 1) * limit + 1 }} to {{ Math.min(currentPage * limit, total) }} of {{ total }} entries
                        <span v-if="searchQuery.trim()" class="text-muted">(filtered results)</span>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination">
                          <li class="paginate_button page-item previous" :class="{'disabled': currentPage === 1}">
                            <a @click="changePage(currentPage - 1)" href="#" class="page-link">Previous</a>
                          </li>
                          <li v-for="page in displayedPages" :key="page" class="paginate_button page-item"
                              :class="{'active': page === currentPage}">
                            <a @click="changePage(page)" href="#" class="page-link">{{ page }}</a>
                          </li>
                          <li class="paginate_button page-item next" :class="{'disabled': currentPage === totalPages}">
                            <a @click="changePage(currentPage + 1)" href="#" class="page-link">Next</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Import Modal Components -->
      <RegisterHouseholdModal
          v-if="showRegisterModal"
          @close="showRegisterModal = false"
          @registered="onHouseholdRegistered"
      />

      <HouseholdMapView
          v-if="showMapView"
          :households="households"
          @close="showMapView = false"
          @select="viewHousehold"
      />

      <StartVisitModal
          v-if="showVisitModal"
          :household="selectedHousehold"
          @close="showVisitModal = false"
          @started="onVisitStarted"
      />

      <EditHouseholdModal
          v-if="showEditModal"
          :household="selectedHousehold"
          @close="showEditModal = false"
          @updated="onHouseholdUpdated"
      />

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">© CBHI</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Ministry of Health - Ethiopia
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import RegisterHouseholdModal from "@/components/hew/modals/RegisterHouseholdModal.vue";
import HouseholdMapView from "@/components/hew/modals/HouseholdMapView.vue";
import StartVisitModal from "@/components/hew/modals/StartVisitModal.vue";
import EditHouseholdModal from "@/components/hew/modals/EditHouseholdModal.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";

export default {
  name: "HouseholdManagement",
  components: {
    NavigationBar,
    RegisterHouseholdModal,
    HouseholdMapView,
    StartVisitModal,
    EditHouseholdModal
  },
  data() {
    return {
      // Loading states
      loading: false,
      searchLoading: false,

      // Data
      households: [],
      selectedHousehold: null,
      statistics: {
        cbhi_enrolled: 0,
        model_households: 0,
        vulnerable: 0
      },

      // Filters and search
      filter: 'all',
      searchQuery: '',
      searchTimeout: null,

      // Pagination
      currentPage: 1,
      limit: 20,
      total: 0,

      // UI States
      showRegisterModal: false,
      showMapView: false,
      showVisitModal: false,
      showEditModal: false,

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.total / this.limit);
    },

    displayedPages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    }
  },

  mounted() {
    this.loadHouseholds();
  },

  methods: {
    async loadHouseholds() {
      this.loading = true;

      const data = {
        "function": "getHouseholds",
        "filter": this.filter,
        "searchTerm": this.searchQuery.trim(),
        "limit": this.limit,
        "offset": (this.currentPage - 1) * this.limit
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.households = res.data.data.households || [];
          this.total = res.data.data.total || 0;
          this.calculateStatistics();
        } else {
          this.showAlert('failed', res.data.message || 'Failed to load households');
        }
      } catch (e) {
        console.error("Failed to load households:", e);
        this.showAlert('failed', 'Failed to load households');
      } finally {
        this.loading = false;
        this.searchLoading = false;
      }
    },

    calculateStatistics() {
      // Calculate statistics from loaded households
      this.statistics = {
        cbhi_enrolled: this.households.filter(h => h.cbhi_member_count > 0).length,
        model_households: this.households.filter(h => h.is_model_household).length,
        vulnerable: this.households.filter(h => h.is_vulnerable).length
      };
    },

    // Search functionality
    onSearchInput() {
      // Clear existing timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Set new timeout for debounced search
      this.searchTimeout = setTimeout(() => {
        this.performSearch();
      }, 500); // 500ms delay
    },

    async performSearch() {
      // Clear any pending search timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }

      // Reset to first page when searching
      this.currentPage = 1;
      this.searchLoading = true;

      await this.loadHouseholds();
    },

    // Highlight search terms in results
    highlightSearchTerm(text) {
      if (!text || !this.searchQuery.trim()) {
        return text;
      }

      const searchTerm = this.searchQuery.trim();
      const regex = new RegExp(`(${this.escapeRegExp(searchTerm)})`, 'gi');
      return text.replace(regex, '<mark class="bg-warning">$1</mark>');
    },

    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    filterHouseholds(filterType) {
      this.filter = filterType;
      this.currentPage = 1;
      this.loadHouseholds();
    },

    clearFilter() {
      this.filter = 'all';
      this.searchQuery = '';
      this.currentPage = 1;

      // Clear any pending search timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }

      this.loadHouseholds();
    },

    async changePage(page) {
      if (page < 1 || page > this.totalPages) return;

      this.currentPage = page;
      await this.loadHouseholds();
    },

    startVisit(household) {
      this.selectedHousehold = household;
      this.showVisitModal = true;
    },

    viewHousehold(household) {
      sessionStorage.setItem("household_id", household.household_id);
      router.push(`household-details`);
    },

    editHousehold(household) {
      this.selectedHousehold = household;
      this.showEditModal = true;
    },

    // Modal callbacks
    onHouseholdRegistered() {
      this.showRegisterModal = false;
      this.showAlert('success', 'Household registered successfully');
      this.loadHouseholds();
    },

    onVisitStarted(visitData) {
      this.showVisitModal = false;
      router.push(`/hew/visits/${visitData.visitId}`);
    },

    onHouseholdUpdated() {
      this.showEditModal = false;
      this.showAlert('success', 'Household updated successfully');
      this.loadHouseholds();
    },

    // Utility methods
    getFilterLabel() {
      const labels = {
        'all': 'All Households',
        'cbhi': 'CBHI Members',
        'non-cbhi': 'Non-CBHI',
        'model': 'Model Households',
        'vulnerable': 'Vulnerable'
      };
      return labels[this.filter] || 'All Households';
    },

    getInitials(name) {
      if (!name) return '?';
      const parts = name.split(' ');
      return parts.map(p => p[0]).join('').toUpperCase().slice(0, 2);
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },

    getDaysSinceVisit(dateString) {
      if (!dateString) return 0;
      const visitDate = new Date(dateString);
      const today = new Date();
      const diffTime = Math.abs(today - visitDate);
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    },

    // Alert methods
    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts();
        }, 5000);
      }
    }
  },

  // Cleanup on component destroy
  beforeUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
};
</script>

<style scoped>
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 600;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  background-color: #f8f9fa;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #999;
  z-index: 10;
}

.search-icon:hover {
  color: #007bff;
}

.filter-tool-bar-btns .btn-group {
  margin-right: 5px;
}

/* Search highlighting */
mark.bg-warning {
  background-color: #fff3cd !important;
  padding: 0 2px;
  border-radius: 2px;
}

/* Search input improvements */
.search-box input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.search-box input:disabled {
  background-color: #f8f9fa;
  opacity: 0.6;
}

/* Loading states */
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

/* Search results info */
.alert-info {
  border-color: #bee5eb;
  background-color: #d1ecf1;
}

/* Responsive improvements */
@media (max-width: 768px) {
  .search-box {
    margin-bottom: 1rem;
  }

  .btn-toolbar {
    flex-direction: column;
    align-items: stretch !important;
  }

  .btn-toolbar .d-flex {
    justify-content: center;
    margin-top: 0.5rem;
  }
}
</style>